<style>
	.letter-flag{
		padding: .7em 1em;
		margin: 0;
		font-size: .9em;
		color: #999;
		float: left;
	}
	.letter-ullist{
		position: absolute;
		right: 5px;
		top: 46px;
		border: solid 1px #ddd;
		padding: 5px;
		border-radius: 5px;
		background-color: #fff;
		z-index: 10;
	}
	.letter-ullist li{
		width: 10px;
		height: 14px;
		margin: 3px 0px;
	}
	.letter-ullist li a{
		font-size: .7em;

	}
	 .edi-allorderbill .ui-billcount-detail-listview li:nth-child(2n) {
	    position: relative;
	}
	.edi-allorderbill .billcount-detail-total{
		position: fixed;
		width: 100%;
		left: 0;
		bottom: 0;
		box-shadow: 0 17px 36px 6px rgba(0,0,0,.5);
		padding: 0 0 15px;
		z-index: 1020;
	}
	.edi-allorderbill .list-container{

	}
	.edi-total-second{
		position: fixed;
		width: 80px;
		height: 80px;
		background-color: #e02222;
		bottom: -40px;
		left: -40px;
		border-radius: 50%;
		text-align: center;
		line-height: 34px;
		color: #fff;
		transform: rotate(45deg);
		-ms-transform: rotate(45deg);
		-webkit-transform: rotate(45deg);
		z-index: 1010;
	}

</style>
<template>
<div class="edi-allorderbill">
	<navbar title="单据统计-机构"></navbar>
	<div class="common-scroll">
		<div class="list-container" v-for="billCountDetail in billCountDetails">
			<p class="letter-flag" :id="billCountDetail.phonetic" v-if="hasAlpha(billCountDetail.phonetic)">{{billCountDetail.phonetic}}</p>
			<ul class="ui-listview" style="padding-bottom: 0">
				<li style="margin-bottom: 0">
					<router-link :to="{ path: '/bill-count-serial', query: { restaurant_id: queryData.restaurant_id, bill_state: queryData.bill_state, start_date: queryData.start_date, end_date: queryData.end_date, organ_id: billCountDetail.organ_id, organ_type: billCountDetail.organ_type }}">
						<p class="allorderbill-list-p">{{queryData.restaurant_name}} - {{billCountDetail.organ_name}}</p>
						<ul class="ui-detail-listview ui-billcount-detail-listview">
							<li>订货金额：{{billCountDetail.order_bill_money}}元</li>
							<li>实收金额: {{billCountDetail.sum_money_recipient}}元</li>
							<li>订货单：共{{billCountDetail.order_bill_num}}张</li>
							<li>发货金额：{{billCountDetail.deliver_money}}元</li>
							<li>退货单：共{{billCountDetail.reverse_bill_num}}张</li>
							<li>退货金额：{{billCountDetail.reverse_money}}元</li>
							<li>发货减实收：{{(billCountDetail.deliver_money - billCountDetail.sum_money_recipient) | filterFloat}}元</li>
							<li>实收减退货：{{(billCountDetail.sum_money_recipient - billCountDetail.reverse_money) | filterFloat}}元</li>
						</ul>
					</router-link>
				</li>
			</ul>
		</div>
	</div>
	<get-total :filter="queryData" href="/cldEdi/business/getTotalByRestaurantId" name="机构"></get-total>
	<loading v-show="loading"></loading>
	<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
	<ul class="letter-ullist" v-show="show">
		<li><a href="##">#</a></li>
		<li v-for="(letter, index) in letters">
			<a :href="anchor(letter)">{{letter}}</a>
		</li>
	</ul>
</div>
</template>
<script>
import GetTotal from '../components/GetTotal'
import Loading from '../components/loading'
import TipsAuto from '../components/TipsAuto'
import NavBar from '../components/NavBar'
var oldAlpha = ''
export default {
	data () {
		return {
			tipsauto: false,
			tipsFont: '',
			sec: 1500,
			loading: true,
			show: false,
			billCountDetails: {},
			totalSum: {},
			queryData: this.$route.query,
			letters: []
		}
	},
	components: {
		'get-total': GetTotal,
		'loading': Loading,
		'tips-auto': TipsAuto,
		'navbar': NavBar
	},
	methods: {
		hasAlpha (item) {
			var b = item !== oldAlpha
			oldAlpha = item
			return b
		},
		anchor (val) {
			return '#' + val
		},
		letterFilter () {
			var data = this.billCountDetails
			for (var i = 0; i < data.length; i++) {
				if (this.letters.indexOf(data[i].phonetic) === -1) {
					this.letters.push(data[i].phonetic)
				}
			}
		}
	},
	created () {
		oldAlpha = ''
		this.loading = true
		var filterData = {
			bill_state: this.queryData.bill_state,
			restaurant_id: this.queryData.restaurant_id,
			start_date: this.queryData.start_date,
			end_date: this.queryData.end_date
		}
		this.$http.post('/cldEdi/business/getTotalDetailByRestaurantId', filterData).then((response) => {
			this.loading = false
			if (response.body.result) {
				this.show = true
				this.billCountDetails = response.body.data
				this.letterFilter()
			} else {
				var self = this
				self.tipsauto = true
				self.tipsFont = response.body.message
				setTimeout(() => {
					self.tipsauto = false
				}, self.sec)
			}
		}, (response) => {
			var self = this
			self.tipsauto = true
			self.tipsFont = '服务中断，稍后请重试！'
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		})
	}
	// filters: {
	// 	nullToZero: function (value) {
	// 		if (!value) {
	// 			return 0
	// 		} else {
	// 			return value
	// 		}
	// 	}
	// }
}
</script>



// WEBPACK FOOTER //
// BillCountDetail.vue?a616c56c